import { withDevTools } from '../../utils/with-dev-tools';
import { wrapServiceWithResult } from '../../utils/wrap-service-with-result';
const getMemberFolloApi = async () => import(/* webpackChunkName: "members-v3-follow" */ '@wix/ambassador-members-v3-follow/http');
export function createMembersService({ httpClient, getDevState, onError, }) {
    const service = (() => {
        const api = {
            followMember: followMember(httpClient),
            unfollowMember: unfollowMember(httpClient),
        };
        return withDevTools(api, getDevState);
    })();
    return wrapServiceWithResult(service, {
        errorEffect: onError,
    });
}
const followMember = (httpClient) => async (payload) => {
    const membersFolowApi = await getMemberFolloApi();
    await httpClient.request(membersFolowApi.followMember(payload));
};
const unfollowMember = (httpClient) => async (payload) => {
    const membersFolowApi = await getMemberFolloApi();
    await httpClient.request(membersFolowApi.unfollowMember(payload));
};
//# sourceMappingURL=create-members-service.js.map